import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { extractAddress } from '../helper'
import TronWalletInfo from '../WalletInfo/TronWalletInfo';
import TronContext from '../../../../TronContext';

export default function TronWalletConfig({
  amount,
  allBalance,
  selectedChain,
  selectedToken,
  setAddress,
}) {

  const { account, connectWallet, disconnectWallet } = useContext(TronContext);

  useEffect(() => {
    if (account) {
      setAddress(account);
    } else {
      setAddress("");
    }
  }, [account, setAddress])

  return (
    <div>
      <div className="title-block">
        <strong >
          {
            account ? `Wallet address ${extractAddress(account)}` : " Connect your wallet"
          }
        </strong>
      </div>
      <div className='mt-3'>
        <div className="p-3 text-dark">
          {
            !account ?
              <div>
                <p className='mb-4 wallet-info-text'>
                  You have selected a network and token for this transaction. To continue, click the <b>Pay</b> button below.
                  Once you proceed, you will be prompted to securely connect your wallet via WalletConnect. This step ensures a safe and encrypted connection between your wallet and the application.
                  <br /><br />
                  After your wallet is successfully connected, the payment process will start automatically. Please review the transaction details in your wallet and confirm it to complete the payment.
                  <br /><br />
                  Make sure your wallet has sufficient balance and is connected to the correct network before proceeding.
                </p>
              </div> :
              <div>
                <TronWalletInfo
                  amount={amount}
                  allBalance={allBalance}
                  selectedChain={selectedChain}
                  selectedToken={selectedToken}
                />
                <div className="d-flex justify-content-end mt-3">
                  <Button size='sm' variant="danger" onClick={disconnectWallet}>Disconnect Wallet</Button>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}